import TjenesteIconBlock from './TjenesteIconBlock';

globalThis.TjenesteIconComponents = {
  TjenesteIconBlock,
};
